require('./passStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { recordLinkV2 } = require("utilities/tagging");

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { AmountInput } = require('commonsComponents/amountInput');
const InputCharsLeft = require('components/inputCharsLeft/inputCharsLeft');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const { OKLink } = require("commonsComponents/OKLink");
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @ constants
const { FIRST_STEP, EURO_SYMBOL, TRANSFER_MIN_IMPORT, TRANSFER_MAX_IMPORT, MODAL_MAX_LIMIT_EVENT, MODAL_MAX_LIMIT_ERROR } = require('constants/index');
const {
    TRANSFERS_POPUP_25K_MORE
} = require('constants/flagBasedFeatures');
class PassStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            internalTransferLimitModalStatus: false,
            amountTransfer: 0
        };
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
        this.handleAccountToChange = this.handleAccountToChange.bind(this);
        this.handleToggleShowModal = this.handleToggleShowModal.bind(this);
        this.doTagging = this.doTagging.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleAccountFromChange(accountId, isInitialAccount = false) {
        const { actions: { setFromAccount }, immAccounts, immPassState } = this.props;
        
        const isPredefinedToAccount = immPassState.get('isPredefinedToAccount')

        if (accountId) {
            const amount = immAccounts.getIn([accountId, 'balances', 'availableBalance', 'amount']);
            setFromAccount(accountId, amount, isInitialAccount, isPredefinedToAccount);
        } else {
            setFromAccount(null, null, null, isPredefinedToAccount);
        }
    }

    handleAccountToChange(accountId) {
        const { actions: { setToAccount }, immAccounts } = this.props;

        if (accountId) {
            const currency = immAccounts.getIn([accountId, 'balance', 'currency']);
            setToAccount(accountId, currency);
        } else {
            setToAccount();
        }
    }
    callBackChangeAmount = amountTransfer => {
        const { actions, depositLimits, immFlagBasedFeatures } = this.props;
        const maxTransferLimit = +depositLimits.get('maxTransferLimit');
        if(amountTransfer > maxTransferLimit && immFlagBasedFeatures.get(TRANSFERS_POPUP_25K_MORE) && !__CONTACT_CENTER__)
        {   actions.setAmount(amountTransfer,maxTransferLimit);
            this.handleToggleShowModal('open')
        }
        else {
            actions.setAmount(amountTransfer);
        }
        if (amountTransfer > 0) {
            this.setState(
                {
                    amountTransfer
                },
            );
        }
    };
    doTagging(eventType){
    let etiquetaEvento ='';
    switch(eventType){
            case 'open':
                etiquetaEvento = "vista";
                break;
            case 'close':
                etiquetaEvento = "close"; 
                break;   
            case 'continue': 
                etiquetaEvento = "entendido";
                break;   
            default:
                    break;         
        }
        const analyticsData = {
            categoriaEvento: MODAL_MAX_LIMIT_EVENT,
            accionEvento: MODAL_MAX_LIMIT_ERROR,
            etiquetaEvento: etiquetaEvento
            }
        recordLinkV2(analyticsData);
    }

    handleToggleShowModal(eventType) {
        this.setState(previousState => ({
            internalTransferLimitModalStatus: !previousState.internalTransferLimitModalStatus
        }),this.doTagging(eventType));
    }
    getDepositLink() {
        let depositNavigationLink =  (
            <OKLink
                modifier="emphasize"
                onClick={() => this.props.redirectToDeposit(false)} 
                >
                <FormattedText value="transferSummary-maxLimitDepositNavigationLink" />
            </OKLink>
        );
    
        return (<FormattedTextWithComponents
            value="transferSummary-transferModalMaxLimitContent"
            injectedComponents={[depositNavigationLink]}
            />)
    }

    render() {
        const {
            immPassState,
            immAccounts,
            isInactiveAccountsEnabled,
            accountsIndexes,
            initialAccountId,
            immOriginAccounts,
            originAccountsIndexes,
            depositLimits,
            immFlagBasedFeatures,
            disableDestinationAccountOption
        } = this.props;

        const firstStep = immPassState.getIn(['steps', FIRST_STEP]);
        const maxTransferLimit = +depositLimits.get('maxTransferLimit');
        const isPredefinedToAccount = immPassState.get('isPredefinedToAccount');

        if (firstStep.get('isValidating')) {
            return <LoadingSection />;
        }

        //Set the properties for dropdownAccounts component
        const fromAccountId = firstStep.get('fromAccount');
        const toAccountId = firstStep.get('toAccount');
        const toAccountEnabled = !!fromAccountId;

        const concept = firstStep.get('concept');

        const amountAlert = !firstStep.get('amountIsValid') && firstStep.get('amountIsDirty');

        /* fromAccount required message will be displayed if:
           there was user interaction (dirty),
           there is no fromAccount selected */
        const fromAccountRequiredAlertVisible =
            firstStep.get('fromAccountIsDirty') && fromAccountId === '';

        /* display fromAccount negativa balance will be displayed if:
           there was user interaction (dirty),
           there's a fromAccount selected,
           balance from selected account is not valid */
        const fromAccountNegativeBalanceAlertVisible =
            firstStep.get('fromAccountIsDirty') && !firstStep.get('fromAccountIsValid');

        /* toAccount required message will be displayed if:
           there was user interaction (dirty),
           there is no toAccount selected */
        const toAccountRequiredAlertVisible =
            firstStep.get('toAccountIsDirty') && toAccountId === '';

        /* amount zero alert message will be displayed if:
           there was user interaction (dirty),
           the amount field it's not valid because amount is zero */
        const amountZeroAlertVisible = amountAlert && firstStep.get('amount') === 0;

        /* amount excess alert message will be displayed if:
           there was user interaction (dirty),
           the field it's not valid because (fallback from previous variable),
           fromAccount negative balance alert is not visible */
        const amountExcessAlertVisible =
            !fromAccountNegativeBalanceAlertVisible && amountAlert && firstStep.get('amount') > 0;

        const currencySymbol = EURO_SYMBOL; //We always send EUR in POST despite of the destination account currency

        const labelFromAccount = formatText('passStep1-origin');
        const labelToAccount = formatText('passStep1-destination');
        const labelAmount = formatText('passStep1-amount');
        const labelConcept = formatText('passStep1-concept');

        let fromAccountErrorMsg;
        let toAccountErrorMsg;
        let amountErrorMsg;
        let limitCondition1= (this.state.amountTransfer > maxTransferLimit) && immFlagBasedFeatures.get(TRANSFERS_POPUP_25K_MORE) && !__CONTACT_CENTER__;

        if (fromAccountRequiredAlertVisible) {
            fromAccountErrorMsg = formatText('passStep1-requiredMessageAlt', [labelFromAccount]);
        } else {
            fromAccountErrorMsg = formatText('passStep1-fromAccountInvalidMessage');
        }

        if (toAccountRequiredAlertVisible) {
            toAccountErrorMsg = formatText('passStep1-requiredMessageAlt', [labelToAccount]);
        }

        if(limitCondition1) {
            amountErrorMsg = formatText("transferSummary-step1AmountExcessTransferLimit");
        } else if (amountExcessAlertVisible) {
            amountErrorMsg = formatText('passStep1-amountInvalidMessage');
        } else {
            amountErrorMsg = formatText('passStep1-zeroAmount');
        }

        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';
        let transferLimitModal; 
        if(this.state.internalTransferLimitModalStatus){
        const transferModalMaxLimitTitle = formatText("transferSummary-transferModalMaxLimitTitle");
        const transferModalMaxLimitContent = this.getDepositLink();
        const transferModalMaxLimitPrimaryButtonText = formatText('transferSummary-transferModalMaxLimitPrimaryButtonText');
        let modalContent1= (<p>{transferModalMaxLimitContent}</p>);
    
         transferLimitModal = limitCondition1 && (
            <OKModal
                content={modalContent1}
                isOpen={this.state.internalTransferLimitModalStatus}
                onCloseCallback={()=> this.handleToggleShowModal('close')}
                onPrimaryButtonClick={() => this.handleToggleShowModal('continue')}
                primaryButtonText={transferModalMaxLimitPrimaryButtonText}
                title={transferModalMaxLimitTitle}
                footerType="action"
            />
            )
           }
        return (
            <React.Fragment>
            <article className="pass-step-1">
                <header className="pass-step-1__header">
                    <h1 className="pass-step-1__title">
                        <FormattedText value="passStep1-passInformation" />
                    </h1>
                </header>
                <section className="pass-step-1__content">
                    <form id="frm_PassStep1_Info" className="pass-step-1__form">
                        <fieldset className="pass-step-1__field">
                            <DropdownAccounts
                                id="drd_PassStep1_Origin"
                                label={labelFromAccount}
                                immAccounts={immOriginAccounts}
                                accountsIndexes={originAccountsIndexes}
                                currentAccountId={fromAccountId}
                                initialAccountId={initialAccountId}
                                filterId={isPredefinedToAccount ? toAccountId : null}
                                onAccountChange={this.handleAccountFromChange}
                                error={
                                    fromAccountRequiredAlertVisible ||
                                    fromAccountNegativeBalanceAlertVisible
                                }
                                errorMsg={fromAccountErrorMsg}
                                showAvailableBalance={true}
                                tooltipMsg={tooltipMsgContent}
                                showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                            />
                        </fieldset>
                        <fieldset className="pass-step-1__field">
                            <DropdownAccounts
                                id="drd_PassStep1_Destiny"
                                label={labelToAccount}
                                immAccounts={immAccounts}
                                accountsIndexes={accountsIndexes}
                                currentAccountId={toAccountId}
                                disableOptionCriteria={disableDestinationAccountOption || undefined}
                                enabled={isPredefinedToAccount ? false : toAccountEnabled}
                                filterId={fromAccountId}
                                onAccountChange={this.handleAccountToChange}
                                error={toAccountRequiredAlertVisible}
                                errorMsg={toAccountErrorMsg}
                                showAvailableBalance={true}
                            />
                        </fieldset>
                        <fieldset className="pass-step-1__field">
                            <div className="pass-step-1__amount">
                                <AmountInput
                                    id="inp_PassStep1_Amount"
                                    label={labelAmount}
                                    callback={this.callBackChangeAmount}
                                    min={TRANSFER_MIN_IMPORT}
                                    max={TRANSFER_MAX_IMPORT}
                                    showBlurZero
                                    hideFocusZero
                                    disablePaste
                                    error={amountZeroAlertVisible || amountExcessAlertVisible}
                                    errorMsg={amountErrorMsg}
                                    amount={firstStep.get('amount')}
                                    language={getLanguage()}
                                />
                            </div>
                            <div className="pass-step-1__currency">
                                {currencySymbol}
                            </div>
                        </fieldset>
                        <fieldset className="pass-step-1__field">
                            <InputCharsLeft
                                id="inp_PassStep1_Concept"
                                maxLength="50"
                                label={labelConcept}
                                initialValue={concept}
                                callback={this.props.actions.setConcept}
                            />
                        </fieldset>
                    </form>
                </section>
            </article>
             {transferLimitModal}
             </React.Fragment>
        );
    }
}

PassStep1.propTypes = {
    actions: PropTypes.object,
    accountsIndexes: PropTypes.array,
    disableDestinationAccountOption: PropTypes.func,
    immAccounts: PropTypes.object,
    immPassState: PropTypes.object,
    initialAccountId: PropTypes.string,
    immOriginAccounts: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    originAccountsIndexes: PropTypes.array,
    depositLimits: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    redirectToDeposit: PropTypes.func
};

module.exports = PassStep1;
